<script setup lang="ts">
import type { FrequencyType } from '../../types/global'
import useFrequencyType from '@/composables/frequencyType'

const { t } = useI18n()

defineProps<{
  width: string
  data: FrequencyType[]
}>()

const { getBgColorBySlug, getHexaColorBySlug, description } = useFrequencyType()
</script>

<template>
  <div class="hidden lg:block">
    <AppTooltip :width="`${width} z-50`" tooltip-position="right">
      <BaseIcon
        name="HeroExclamationCircleIconOutline"
        class="mr-2 h-5 w-5 rotate-180 transform cursor-pointer text-foreground-secondary"
      />
      <template #tooltip-content>
        <div>
          <h2 class="m-2 mb-3 text-left text-lg text-foreground-disabled">
            {{ t('pages.campaign.campaignTargetBlock.frequencyDescription.title') }}
          </h2>
          <div class="m-2 flex flex-col gap-2">
            <div v-for="(frequency, index) in data" :key="index" class="flex items-center">
              <div
                :class="`${getBgColorBySlug(frequency.frequency_type)} w-1/3 p-2.5 rounded-md text-sm font-medium`"
                :style="`color: ${getHexaColorBySlug(frequency.frequency_type)}`"
              >
                {{ t(`global.frequencyTypes.${frequency.frequency_type}`, { defaultValue: frequency.frequency_type }) }}
              </div>
              <p class="flex min-h-[4rem] w-2/3 items-center pl-2 text-left">
                <span>{{ description(frequency) }}</span>
              </p>
            </div>
          </div>
        </div>
      </template>
    </AppTooltip>
  </div>
</template>
